import React from 'react';
import { Link } from 'react-router-dom';
import '../../assets/css/Zoom.css';

const SectorLink = ({ route, src, name }) => {
    return (
        <Link to={route} style={{ color: `#FFFFFF`, textDecoration: `none` }}>
            <img src={`/images/zacatecas-en-cifras/${src}`} width='150' height='150' className='zoom-sector' alt={name} />
            <div className="text-center">
                <h4 style={{ color: '#FFFFFF' }}>{name}</h4>
            </div>
        </Link>
    );
}
export default SectorLink;
